module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    attrs: {
      "label": this.label
    }
  }, [_c('el-cascader', {
    attrs: {
      "options": _vm.options,
      "disabled": _vm.disabled,
      "lazy": ""
    },
    on: {
      "change": _vm.userUpdated
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }), _vm._v(" "), (_vm.isManager()) ? _c('el-checkbox', {
    attrs: {
      "label": "Manager"
    },
    model: {
      value: (_vm.man),
      callback: function($$v) {
        _vm.man = $$v
      },
      expression: "man"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-134d58e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/selects/SelectUsers.vue
// module id = 1331
// module chunks = 0